// WhatsApp Ads data + mutations (PRD §4.15). Campaigns read from
// tenants/{t}/adCampaigns (members read); writes via owner/admin callables. The
// tracked click link routes through the adClick redirect (counts clicks → wa.me).
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions, adClickUrl } from './firebase';
import { useTenant } from './tenant';

export interface AdCampaign {
  id: string;
  name: string;
  prefill: string;
  ref: string;
  clicks: number;
  createdAt: number;
}

export function useAdCampaigns(): { campaigns: AdCampaign[]; loading: boolean } {
  const { tenantId } = useTenant();
  const [campaigns, setCampaigns] = useState<AdCampaign[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!tenantId) { setCampaigns([]); setLoading(false); return; }
    const q = query(collection(db, `tenants/${tenantId}/adCampaigns`), orderBy('createdAt', 'desc'));
    return onSnapshot(q, (snap) => {
      setCampaigns(snap.docs.map((d) => {
        const c = d.data() as Partial<AdCampaign>;
        return { id: d.id, name: c.name ?? '', prefill: c.prefill ?? '', ref: c.ref ?? '', clicks: c.clicks ?? 0, createdAt: c.createdAt ?? 0 };
      }));
      setLoading(false);
    }, () => setLoading(false));
  }, [tenantId]);
  return { campaigns, loading };
}

export interface AdInput { id?: string; name: string; prefill: string; }
const saveFn = httpsCallable<AdInput, { ok: boolean; id: string }>(functions, 'adCampaignSave');
const deleteFn = httpsCallable<{ id: string }, { ok: boolean }>(functions, 'adCampaignDelete');
export const saveCampaign = (i: AdInput) => saveFn(i).then((r) => r.data);
export const deleteCampaign = (id: string) => deleteFn({ id }).then((r) => r.data);

/** The tracked click-to-WhatsApp link to put in an ad. */
export function campaignLink(tenantId: string, campaignId: string): string {
  return `${adClickUrl}?t=${encodeURIComponent(tenantId)}&c=${encodeURIComponent(campaignId)}`;
}
